import { useGridApiRef } from '@mui/x-data-grid';
import type { ReportJobTypes } from '@weft/types';
import type { PartialNever } from '@weft/utils';
import { filterBy, isNotNullOrUndefined, caseInsensitiveIncludes, isNullOrUndefined } from '@weft/utils';
import { useReports } from 'apps/app/src/hooks/requests/use-reports';
import React, { useMemo } from 'react';
import { ReportJobsTable } from './report-jobs-table/ReportJobsTable';

export type ReportJobsDownloadProps = {
  asDownload?: boolean;
  onDownload?: (reportJobId: string) => Promise<void> | void;
};

type ReportJobsSectionProps = {
  reportJobType: ReportJobTypes;
  filter?: string;
} & (Required<ReportJobsDownloadProps> | PartialNever<ReportJobsDownloadProps>);

export const ReportJobsSection: React.FC<ReportJobsSectionProps> = ({ reportJobType, filter, ...downloadProps }) => {
  const { data: reportsData, isLoading: isLoadingReports } = useReports();
  const tableRows = filterBy(reportsData, reportJobType, 'type');
  const filteredRows = useMemo(() => tableRows.filter(({ reportName }) => isNullOrUndefined(filter) || isNotNullOrUndefined(reportName) && caseInsensitiveIncludes(reportName, filter)), [tableRows, filter]);
  const apiRef = useGridApiRef();

  return (
    <>
      <ReportJobsTable
        {...downloadProps}
        itemsCount={filteredRows.length}
        loadingItems={isLoadingReports}
        items={filteredRows}
        apiRef={apiRef}
        showPagination={false}
        hideFooter={false}
      />
    </>
  );
};